import { VideoSkinElement } from '../../presets/video/skin';
import { safeDefine } from '../../registration/safe-define';
import './ui';

safeDefine(VideoSkinElement);
